<template>
  <div>
    <!-- 검색 -->
    <search-nav @handleSearch="handleSearch" class="mb-4">
      <search-nav-year-month label="연도" type="year" yearAfter="" v-model="search.연도" :use-all-year="false" />
      <search-nav-item-select
        label="월"
        v-model="search.분기"
        :list="[
          { value: 0, text: '전체'},
          { value: 1, text: '1월' },
          { value: 2, text: '2월' },
          { value: 3, text: '3월' },
          { value: 4, text: '4월' },
          { value: 5, text: '5월' },
          { value: 6, text: '6월' },
          { value: 7, text: '7월' },
          { value: 8, text: '8월' },
          { value: 9, text: '9월' },
          { value: 10, text: '10월' },
          { value: 11, text: '11월' },
          { value: 12, text: '12월' },
        ]"
      />
      <search-nav-item-field-select label="사업장명" v-model="search.사업장명" @input="handleSearch" size="small"/>
      <vs-select v-model="selectedDivision" style="width: 100px;">
        <vs-select-item v-for="item in divideList" :key="item" :value="item" :text="item" />
      </vs-select>
      <search-select-company-name label="부서명" v-model="search.부서명" @input="handleSearch"/>
      <span style="font-weight: 500; text-align: center">정기안전교육<br/>이수여부</span>
      <vs-select v-model="search.이수여부" style="width: 100px;">
        <vs-select-item v-for="item in ['전체', '이수', '미이수']" :key="`search_${item}`" :value="item" :text="item" />
      </vs-select>
    </search-nav>

    <div class="flex justify-end mb-4">
      <vs-button type="border" color="secondary" @click="onClickDownloadExcel">Excel 다운로드</vs-button>
    </div>

    <!-- 총원 -->
    <table class="total mb-5">
      <colgroup>
        <col width="240" />
      </colgroup>
      <thead>
      <tr>
        <th>구분</th>
        <th>정기안전교육</th>
        <th>특별안전보건교육</th>
        <th>채용시 안전교육</th>
        <th>작업내용 변경시 안전교육</th>
<!--        <th>안전보건총괄책임자 교육</th>-->
<!--        <th>안전보건관리책임자 교육</th>-->
<!--        <th>관리감독자 안전교육</th>-->
        <th>MSDS</th>
        <th>기타</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>현업근로자 기준 이수시간</td>
        <td>반기별 12시간 이상<br/>(월별 2시간 이상)</td>
        <td>16시간 이상 (최초4시간, 12시간은 3개월 이내 분할 실시), 단기 또는 간헐적 작업은 2시간 이상</td>
        <td>8시간 이상</td>
        <td>2시간 이상</td>
<!--        <td>-</td>-->
<!--        <td>-</td>-->
<!--        <td>-</td>-->
        <td>-</td>
        <td>-</td>
      </tr>
      <tr>
        <td>
          <div class="flex items-center justify-center gap-1"><feather-icon icon="AlertCircleIcon" style="width: 16px; height: 16px" class="cursor-pointer" @click="showPopup = true" /> 이수자/총원</div>
        </td>
        <fragment v-if="summary.count">
          <td class="circle" :class="summary.count <= 정기안전교육이수자수 && 'green'">{{ 정기안전교육이수자수 }}명 / {{ summary.count }}명</td>
          <td class="circle" :class="summary['특별안전보건교육'] && summary.count <= summary['특별안전보건교육'][16] && 'green'">{{ summary["특별안전보건교육"] ? summary["특별안전보건교육"][16] : 0 }}명 / {{ summary.count }}명</td>
          <td class="circle" :class="summary['채용시 안전교육'] && summary.count <= summary['채용시 안전교육'][8] && 'green'">{{ summary["채용시 안전교육"] ? summary["채용시 안전교육"][8] : 0 }}명 / {{ summary.count }}명</td>
          <td class="circle" :class="summary['작업내용 변경시 안전교육'] && summary.count <= summary['작업내용 변경시 안전교육'][2] && 'green'">
            {{ summary["작업내용 변경시 안전교육"] ? summary["작업내용 변경시 안전교육"][2] : 0 }}명 / {{ summary.count }}명
          </td>
        </fragment>
        <fragment v-else>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
        </fragment>
<!--        <td>-</td>-->
<!--        <td>-</td>-->
<!--        <td>-</td>-->
        <td>-</td>
        <td>-</td>
      </tr>
      </tbody>
    </table>

    <!-- 리스트 -->
    <CustomOptionSelector
      :options="[
        { value: 20, text: '20개씩 보기' },
        { value: 50, text: '50개씩 보기' },
        { value: 100, text: '100개씩 보기' },
      ]"
      v-model="perPage"
      class="mb-4"
    />
    <table class="list">
      <colgroup>
        <col width="60" />
      </colgroup>
      <thead>
      <tr>
        <th>No.</th>
        <th>팀명</th>
        <th>사업장명</th>
        <th>구분/직종</th>
        <th>성명</th>
        <th>정기안전교육</th>
        <th>특별안전보건교육</th>
        <th>채용시 안전교육</th>
        <th>작업내용 변경시 안전교육</th>
<!--        <th>안전보건총괄책임자 교육</th>-->
<!--        <th>안전보건관리책임자 교육</th>-->
<!--        <th>관리감독자 안전교육</th>-->
        <th>MSDS</th>
        <th>기타</th>
      </tr>
      </thead>
      <tbody v-if="loading">
      <tr>
        <td colspan="13">
          <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px;">
            <feather-icon icon="LoaderIcon" class="mr-2 rotate-icon" />
            데이터를 불러오는 중입니다.
          </div>
        </td>
      </tr>
      </tbody>
      <tbody v-else-if="list.length > 0">
      <fragment v-for="(item, _index) in currentPageList" :key="item.employee.id">
        <tr>
          <td>{{ (page - 1) * perPage + _index + 1 }}</td>
          <td>{{ item.company.com_name || '-' }}</td>
          <td>{{ item.field.field_name || '-' }}</td>
          <td>{{ getEmployeeType(item) }}</td>
          <td>{{ item.employee.full_name }}</td>
          <td :class="교육_클래스('정기안전교육', item)">
            {{ findEducation("정기안전교육", item.educationHours).text }}
          </td>
          <td :class="교육_클래스('특별안전보건교육', item)">
            {{ findEducation("특별안전보건교육", item.educationHours).text }}
          </td>
          <td :class="교육_클래스('채용시 안전교육', item)">
            {{ findEducation("채용시 안전교육", item.educationHours).text }}
          </td>
          <td :class="교육_클래스('작업내용 변경시 안전교육', item)">
            {{ findEducation("작업내용 변경시 안전교육", item.educationHours).text }}
          </td>
<!--          <td>{{ findEducation("안전보건총괄책임자 교육", item.educationHours).text || "-" }}</td>-->
<!--          <td>{{ findEducation("안전보건관리책임자 교육", item.educationHours).text || "-" }}</td>-->
<!--          <td>{{ findEducation("관리감독자 안전교육", item.educationHours).text || "-" }}</td>-->
          <td>{{ findEducation("MSDS", item.educationHours).text || "-" }}</td>
          <td>{{ findEducation("기타", item.educationHours).text || "-" }}</td>
        </tr>
      </fragment>
      </tbody>
      <tbody v-else>
      <tr>
        <td colspan="13">
          <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px;">
            <feather-icon icon="AlertTriangleIcon" class="mr-2"/>
            표시할 데이터가 없습니다.
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="vs-con-table">
      <div class="con-pagination-table vs-table--pagination">
        <k-pagination :total="total" v-model="page" @change="handleChangePage"></k-pagination>
      </div>
    </div>

    <vs-popup title="교육 이수자/총원" :active.sync="showPopup" id="alertUserSelectPopup">
      <div style="font-weight: 500; font-size: 14px; line-height: 20px">
        1명의 종사자가 N개의 사업장에 참여하고 있으면, 각 사업장별로 1명씩 N명으로 카운트 <br />
        예) "홍길동" 이라는 종사자가 "A사업장"에서는 교육 시간을 충족하고, "B사업장"에서는 충족하지 않으면, <b>이수자/총원 = 1명/2명</b>
      </div>
      <div>
        <p style="font-weight: 500; font-size: 14px; line-height: 20px" class="mt-3 mb-1">참고</p>
        <div style="font-weight: 400; font-size: 14px; line-height: 20px; border: 1px solid #cdcdcd" class="p-2">
          ｢산업안전보건법」은 단위 사업장별로 그 업종, 규모 등에따라적용하므로 본사, 공장, 지점, 영업소, 출장소 등이 장소적으로분산되어 있는 경우에는 원칙적으로 각각 별개의 사업장으로 보아야함.
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import HttpRequest from "@/util/HttpRequest";
import DiffData from "@/views/boards/single-page/434/DiffData.js";

import SearchNav from "@/components/nav/SearchNav";
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavItemRadio from "@/components/nav/SearchNavItemRadio";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemCompany from "@/components/nav/SearchNavItemCompany.vue";
import SearchNavItemFieldSelect from "@/components/nav/SearchNavItemFieldSelect";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import KPagination from "@/components/kPagination/kPagination";
import ExcelJS from "exceljs";
import excelSupporter from "@/excelSupporter";
import SearchSelectCompanyName from "@/views/list/components/SearchSelectCompanyName.vue";

export default {
  components: {
    SearchSelectCompanyName,
    SearchNav,
    SearchNavYearMonth,
    SearchNavItemSelect,
    SearchNavItemRadio,
    SearchNavItemKeyword,
    SearchNavItemCompany,
    SearchNavItemFieldSelect,
    CustomOptionSelector,
    KPagination,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    diffData() {
      return DiffData;
    },
    total() {
      const _total = Math.ceil(this.list.length / this.perPage);
      return _total < 1 ? 1 : _total;
    },
    currentPageList() {
      return this.list.slice((this.page - 1) * this.perPage, this.page * this.perPage);
    },
    /**
     * "월" 조건이 있으면, 2시간 이상, 없으면 12시간 이상
     * @returns {number|*}
     */
    정기안전교육이수자수() {
      // hourIndex 값이, 해당 시간 이상 이수한 종사자 수를 의미한다.
      let hourIndex = 12;
      if (this.search.분기 > 0) {
        hourIndex = 2;
      }

      if (this.summary["정기안전교육"] && this.summary["정기안전교육"][hourIndex]) {
        return this.summary["정기안전교육"][hourIndex];
      } else {
        return 0;
      }
    },
    companyTree() {
      const _data = this.$store.state.company.companyTree;
      if (_data.length && 0 < _data.length) return _data;
      else return [];
    },
  },
  data() {
    return {
      loading: false,
      showPopup: false,

      search: {
        연도: { year: new Date().getFullYear(), month: "" },
        분기: "",
        교육구분: "",
        구분: "사업장별",
        사업장명: "",
        부서명: "",
        사번: "",
        이수여부: "전체",
      },

      page: 1,
      perPage: 20,
      list: [],
      summary: {},
      // 종사자 구분 필터
      selectedDivision: "전체",
      divideList: [
        "전체",
        "사무직",
        "현업 - 청사 등 유지관리",
        "현업 - 도로의 유지·보수 종사자",
        "현업 - 환경미화종사자",
        "현업 - 폐기물 수거처리",
        "현업 - 공원·녹지 유지관리",
        "현업 - 산림조사·보호",
        "현업 - 조리시설",
        "현업",
        "노동자",
        "청원경찰",
        "기타",
      ],
      // Promise 캐시를 저장할 객체 추가
      requestCache: {
        aggregation: null,
        summary: null
      }
    };
  },
  async created() {
    await this.$store.dispatch("company/LOAD_COMPANY_TREE", {projectId: this.projectId, all: true});
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    async handleSearch() {
      if (!this.search.연도) {
        alert("연도를 선택해주세요.");
        return;
      }
      const findCompany = this.companyTree.find((company) => company.descendant.com_name === this.search.부서명)
      const params = {
        year: this.search.연도.year,
        month: this.search.분기 ? this.search.분기 : undefined,
        // quarter: this.search.분기,
        // education_type: this.search.교육구분,
        employee_number: this.search.사번,
        sum_all: 'true',
      };

      if (this.search.구분 === "사업장별") params.field_id = this.search.사업장명;
      else params.company_id = this.search.부서명;

      if (this.selectedDivision !== "전체") {
        params.job_category = this.selectedDivision;
      }

      if (findCompany) {
        params.parent_company_id = findCompany.descendant.id;
      }

      if (params.month === undefined) {
        // 해당 년도 12월 31일까지 고용
        params.hire_before = `${this.search.연도.year}-12-31`;
        // 해당 년도 1월 1일부터 퇴임
        params.retirement_after = `${this.search.연도.year}-01-01`;
      } else {
        // 해당 년도 해당 월 마지막 일 전까지 고용
        const lastDay = new Date(this.search.연도.year, params.month, 0).getDate();
        params.hire_before = `${this.search.연도.year}-${params.month.toString().padStart(2, '0')}-${lastDay}`;
        // 해당 년도 해당 월 첫째 일부터 퇴임
        params.retirement_after = `${this.search.연도.year}-${params.month.toString().padStart(2, '0')}-01`;
      }

      this.loading = true;

      // 각 API 요청에 대한 Promise 생성 또는 재사용하는 함수
      const getOrCreatePromise = (cacheKey, apiPath) => {
        // 이미 진행 중인 요청이 있으면 그것을 반환
        if (this.requestCache[cacheKey]) {
          return this.requestCache[cacheKey];
        }

        // 새로운 요청 생성
        const promise = HttpRequest.get(apiPath, {params})
          .finally(() => {
            // 요청이 완료되면 캐시 초기화
            this.requestCache[cacheKey] = null;
          });

        // 생성한 Promise를 캐시에 저장
        this.requestCache[cacheKey] = promise;
        return promise;
      };

      await Promise.all([
        getOrCreatePromise('aggregation', `/api/v1/employee/${this.projectId}/education/aggregation`)
          .then((response) => {
            this.page = 1;

            // (정기안전교육) 이수여부 적용 검색결과
            if (response.length > 0) {
              if (this.search.이수여부 === "전체") {
                this.list = response;
              } else {
                const filteredList = response.filter((item) => {
                  return this.교육_클래스('정기안전교육', item) === 'circle green';
                });

                if (this.search.이수여부 === "이수") {
                  this.list = filteredList;
                } else {
                  this.list = response.filter((item) => !filteredList.includes(item));
                }
              }
            } else {
              this.list = [];
            }
          })
          .catch((/*ignore*/) => {
            this.list = [];
          }),

        getOrCreatePromise('summary', `/api/v1/employee/${this.projectId}/education/aggregation/summary`)
          .then((response) => {
            let data = {};
            let count = 0;
            const fieldEmployeeCount = response.fieldEmployeeCount;
            if (params.field_id) {
              const values = Object.values(fieldEmployeeCount);
              const data = values.find((item) => {
                if (item.field) {
                  return item.field.id === params.field_id;
                }
                return false;
              });
              count = data ? data.employeeCount : 0;
            } else {
              data = fieldEmployeeCount[0];
              count = data.employeeCount;
            }

            // this.summary = { count: data.employeeCount, ...data.education };
            this.summary = {count, ...fieldEmployeeCount[0].education};
          })
          .catch((/*ignore*/) => {
            this.summary = {};
          }),
      ]);
      this.loading = false;
    },
    handleChangePage(page) {
      this.page = page;
    },
    findEducation(label, data) {
      const findLabel = data.find((item) => item.education_type === label);
      return findLabel ? {
        time: Math.floor(findLabel.total_education_hours),
        text: this.floatToTimeString(findLabel.total_education_hours)
      } : {time: 0, text: null};
    },
    floatToTimeString(floatNumber) {
      const hour = Math.floor(floatNumber);
      const minute = Math.round((floatNumber - hour) * 60);

      return `${hour.toString().padStart(2, "0")}시간 ${minute.toString().padStart(2, "0")}분`;
    },
    getEmployeeType(item) {
      // {{ item.employee.job_category }} / {{ item.employee.employment_type }}
      const employee = item.employee;
      if (employee.job_category && employee.employment_type) {
        return `${employee.job_category} / ${employee.employment_type}`;
      } else if (employee.job_category) {
        return employee.job_category;
      } else if (employee.employment_type) {
        return employee.employment_type;
      } else {
        return "-";
      }
    },
    /*
    <td :class="6 <= findEducation('정기안전교육', item.educationHours).time ? 'circle green' : 'circle'">
              {{ findEducation("정기안전교육", item.educationHours).text }}
            </td>
     */
    교육_클래스(type, item) {
      const time = this.findEducation(type, item.educationHours).time;

      let isGreen = false;
      switch (type) {
      case '정기안전교육': {
        if (this.search.분기 === 0) {
          isGreen = time >= 12;
        } else {
          isGreen = time >= 2;
        }
        break;
      }
      case '특별안전보건교육': {
        isGreen = time >= 16;
        break;
      }
      case '채용시 안전교육': {
        isGreen = time >= 8;
        break;
      }
      case '작업내용 변경시 안전교육': {
        isGreen = time >= 2;
        break;
      }
      }
      return isGreen ? 'circle green' : 'circle';
    },

    onClickDownloadExcel () {
      const workbook = new ExcelJS.Workbook();
      // sheet 생성
      const worksheet = workbook.addWorksheet('종사자별 교육이수현황');

      // 컬럼 크기
      for (let i = 1; i <= 14; i++) {
        if (i === 1) {
          worksheet.getColumn(i).width = 2;
        } else if (i === 7) {
          worksheet.getColumn(i).width = 20;
        } else {
          worksheet.getColumn(i).width = 17;
        }
      }


      excelSupporter.addEmpty(worksheet, 1); // 빈 줄 추가
      // 개요
      this.excelDataOutLine(worksheet);
      // 목록
      this.excelDataList(worksheet);

      this.workbookDownload(workbook, `종사자별 교육이수현황 ${new Date().format('yyyy-MM-dd')}`);
    },
    excelDataOutLine (worksheet) {
      const data = [];
      // 헤더
      data.push([
        { value: '구분', style: 'borderFillHead'},
        { value: '정기안전교육', style: 'borderFillHead'},
        { value: '특별안전보건교육', style: 'borderFillHead'},
        { value: '채용시 안전교육', style: 'borderFillHead'},
        { value: '작업내용 변경시 안전교육', style: 'borderFillHead'},
        // { value: '안전보건총괄책임자 교육', style: 'borderFillHead'},
        // { value: '안전보건관리책임자 교육', style: 'borderFillHead'},
        // { value: '관리감독자 안전교육', style: 'borderFillHead'},
        { value: 'MSDS', style: 'borderFillHead'},
        { value: '기타', style: 'borderFillHead'},
      ]);
      data.push([
        { value: '현업근로자 기준 이수시간', style: 'borderFillHead'},
        { value: '반기별 12시간 이상\n(월별 2시간 이상)', style: 'borderFillHead'},
        { value: '16시간 이상 (최초4시간, 12시간은 3개월 이내 분할 실시), 단기 또는 간헐적 작업은 2시간 이상', style: 'borderFillHead'},
        { value: '8시간 이상', style: 'borderFillHead'},
        { value: '2시간 이상', style: 'borderFillHead'},
        // { value: '-', style: 'borderFillHead'},
        // { value: '-', style: 'borderFillHead'},
        // { value: '-', style: 'borderFillHead'},
        { value: '-', style: 'borderFillHead'},
        { value: '-', style: 'borderFillHead'},
      ]);
      data.push([
        { value: '이수자/총원', style: 'borderFillHead'},
        { value: `${ this.정기안전교육이수자수 }명 / ${ this.summary.count }명`, style: 'borderHead'},
        { value: `${ this.summary["특별안전보건교육"] ? this.summary["특별안전보건교육"][16] : 0 }명 / ${ this.summary.count }명`, style: 'borderHead'},
        { value: `${ this.summary["채용시 안전교육"] ? this.summary["채용시 안전교육"][8] : 0 }명 / ${ this.summary.count }명`, style: 'borderHead'},
        { value: `${ this.summary["작업내용 변경시 안전교육"] ? this.summary["작업내용 변경시 안전교육"][2] : 0 }명 / ${ this.summary.count }명`, style: 'borderHead'},
        // { value: '-', style: 'borderHead'},
        // { value: '-', style: 'borderHead'},
        // { value: '-', style: 'borderHead'},
        { value: '-', style: 'borderHead'},
        { value: '-', style: 'borderHead'},
      ]);

      excelSupporter.addTable(worksheet, {
        rowHeightList: [30, 70.0, 22.4],
        colgroup: ['B:F', 'G:G', 'H:H', 'I:I', 'J:J', 'K:K', 'L:L'],
        data
      });
      excelSupporter.addEmpty(worksheet, 1);
    },
    excelDataList (worksheet) {
      const data = [];
      // 헤더
      data.push([
        { value: 'No.', style: 'borderFillHead'},
        { value: '팀명', style: 'borderFillHead'},
        { value: '사업장명', style: 'borderFillHead'},
        { value: '구분/직종', style: 'borderFillHead'},
        { value: '성명', style: 'borderFillHead'},
        { value: '정기안전교육', style: 'borderFillHead'},
        { value: '특별안전보건교육', style: 'borderFillHead'},
        { value: '채용시 안전교육', style: 'borderFillHead'},
        { value: '작업내용 변경시 안전교육', style: 'borderFillHead'},
        { value: 'MSDS', style: 'borderFillHead'},
        { value: '기타', style: 'borderFillHead'},
      ]);

      for (let i = 0; i<this.list.length; i++) {
        const item = this.list[i];
        data.push([
          { value: i + 1, style: 'borderHead'},
          { value: item.company.com_name || '-', style: 'borderHead'},
          { value: item.field.field_name || '-', style: 'borderHead'},
          { value: this.getEmployeeType(item), style: 'borderHead'},
          { value: item.employee.full_name || '-', style: 'borderHead'},
          { value: this.findEducation("정기안전교육", item.educationHours).text, style: 'borderHead'},
          { value: this.findEducation("특별안전보건교육", item.educationHours).text, style: 'borderHead'},
          { value: this.findEducation("채용시 안전교육", item.educationHours).text, style: 'borderHead'},
          { value: this.findEducation("작업내용 변경시 안전교육", item.educationHours).text, style: 'borderHead'},
          { value: this.findEducation("MSDS", item.educationHours).text || "-", style: 'borderHead'},
          { value: this.findEducation("기타", item.educationHours).text || "-", style: 'borderHead'},
        ]);
      }

      excelSupporter.addTable(worksheet, {
        rowHeight: 22.4,
        colgroup: ['B:B', 'C:C', 'D:D', 'E:E', 'F:F', 'G:G', 'H:H', 'I:I', 'J:J', 'K:K', 'L:L'],
        data
      });
      excelSupporter.addEmpty(worksheet, 1);
    },
    async workbookDownload(workbook, fileName) {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${fileName}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }
}
</script>

<style lang="scss" scoped>
table.total {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 10px;
  }

  th,
  td:nth-child(1) {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
  }

  td {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
  }

  tr:last-child td:nth-child(n + 2) {
    background: #fff;
  }
}

table.list {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  background: white;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    background: #fafafa;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    padding: 10px 4px;
  }
}

.circle:before {
  content: "";
  width: 10px;
  height: 10px;
  display: inline-block;
  margin-right: 8px;
  border-radius: 100%;
  background: #ea5455;
}

.green.circle:before {
  background: #28c76f;
}
.rotate-icon {
  animation: rotate 1s linear infinite;
}
</style>
